/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../TimeExtent.js";
import r from "../../TimeInterval.js";
import { ClonableMixin as l } from "../../core/Clonable.js";
import { JSONSupport as i } from "../../core/JSONSupport.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { reader as n } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as s } from "../../core/accessorSupport/decorators/writer.js";
import { timeZoneProperty as m } from "../../time/timeZoneUtils.js";
function p(e, t) {
  return r.fromJSON({
    value: e,
    unit: t
  });
}
let u = class extends l(i) {
  constructor(e) {
    super(e), this.cumulative = !1, this.endField = null, this.fullTimeExtent = null, this.hasLiveData = !1, this.interval = null, this.startField = null, this.timeZone = null, this.trackIdField = null, this.useTime = !0;
  }
  readFullTimeExtent(e, r) {
    if (!r.timeExtent || !Array.isArray(r.timeExtent) || 2 !== r.timeExtent.length) return null;
    const l = new Date(r.timeExtent[0]),
      i = new Date(r.timeExtent[1]);
    return new t({
      start: l,
      end: i
    });
  }
  writeFullTimeExtent(e, t) {
    null != e?.start && null != e.end ? t.timeExtent = [e.start.getTime(), e.end.getTime()] : t.timeExtent = null;
  }
  readInterval(e, t) {
    return t.timeInterval && t.timeIntervalUnits ? p(t.timeInterval, t.timeIntervalUnits) : t.defaultTimeInterval && t.defaultTimeIntervalUnits ? p(t.defaultTimeInterval, t.defaultTimeIntervalUnits) : null;
  }
  writeInterval(e, t) {
    t.timeInterval = e?.toJSON().value ?? null, t.timeIntervalUnits = e?.toJSON().unit ?? null;
  }
};
e([o({
  type: Boolean,
  json: {
    name: "exportOptions.timeDataCumulative",
    write: !0
  }
})], u.prototype, "cumulative", void 0), e([o({
  type: String,
  json: {
    name: "endTimeField",
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], u.prototype, "endField", void 0), e([o({
  type: t,
  json: {
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], u.prototype, "fullTimeExtent", void 0), e([n("fullTimeExtent", ["timeExtent"])], u.prototype, "readFullTimeExtent", null), e([s("fullTimeExtent")], u.prototype, "writeFullTimeExtent", null), e([o({
  type: Boolean,
  json: {
    write: !0
  }
})], u.prototype, "hasLiveData", void 0), e([o({
  type: r,
  json: {
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], u.prototype, "interval", void 0), e([n("interval", ["timeInterval", "timeIntervalUnits", "defaultTimeInterval", "defaultTimeIntervalUnits"])], u.prototype, "readInterval", null), e([s("interval")], u.prototype, "writeInterval", null), e([o({
  type: String,
  json: {
    name: "startTimeField",
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], u.prototype, "startField", void 0), e([o(m("timeReference", !0))], u.prototype, "timeZone", void 0), e([o({
  type: String,
  json: {
    write: {
      enabled: !0,
      allowNull: !0
    }
  }
})], u.prototype, "trackIdField", void 0), e([o({
  type: Boolean,
  json: {
    name: "exportOptions.useTime",
    write: !0
  }
})], u.prototype, "useTime", void 0), u = e([a("esri.layers.support.TimeInfo")], u);
const d = u;
export { d as default };